<template>
  <div id="app">
	 <!-- <router-view></router-view> -->
	 <keep-alive>
	 		 	<router-view :key="$route.fullPath"></router-view>
	 </keep-alive>
	 <BackToTop />
    <!-- <HomePage msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import HomePage from './components/HomePage2.vue'
	import BackToTop from '@/components/BackToTop.vue';

export default {
  name: 'app',
  components: {
    HomePage,
	BackToTop
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
html, body {
  overflow-y: scroll; /* 保证仍然可以滚动 */
  scrollbar-width: none; /* Firefox 隐藏滚动条 */
  margin: 0;
  padding: 0;
  background: #F5F7FC;
}


html::-webkit-scrollbar, 
body::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge 隐藏滚动条 */
}
</style>
